// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".special-title[data-v-55a49957] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n  font-size: 20px;\n}\n.checkout-tab-button[data-v-55a49957] {\n  padding: 13px 0px 13px 0px;\n  display: block;\n}\n.checkout-tab-button p[data-v-55a49957] {\n  font-size: 14px;\n  color: lightgrey;\n  margin-bottom: 0px;\n}\n@media only screen and (max-width: 768px) {\n.special-title[data-v-55a49957] {\n    font-size: 18px;\n    padding-top: 25px;\n    padding-bottom: 25px;\n}\n}", ""]);
// Exports
module.exports = exports;
